import './LeapFrogLoader.scss';

export default function LeapFrogLoader(props){

    const className = 'leapFrogLoader';

    return (
        <div className={className}>
            <div className={className + '__dot'}/>
            <div className={className + '__dot'}/>
            <div className={className + '__dot'}/>
        </div>
    );
}
